<template>
    <br><br>
    <div style="min-height: 100vh;">
        <div class="h-100 d-flex flex-column justify-content-center align-items-center" style="max-width:95%;margin:0 auto">
            <div class="col-md-4 text-center">
                <h3>About App</h3>
            </div>
            <br><br>
            <div class="col-md-4">
                <p style="line-height:30px;">Why pay thousands monthly on personal trainers when you can simply browse and add exercises for your target muscle groups? This app displays instructional gifs for each exercise and gives you the ability to filter through your preferred equipments. This app was created using the <a href="https://rapidapi.com/justin-WFnsXH_t6/api/exercisedb/" target="_blank" color="success">ExerciseDB API</a> and developed by <a href="https://tashyn.com/" target="_blank" color="success">Tashyn</a>. Go to the home page and start adding exercises today!</p>
            </div>
        </div>
    </div>
</template>
